import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { config } from './../../config/config';
const { colorConfig } = config();

const Wrapper = styled.div`
 a {
  background: #0a2f70;
  color: white;
  border-radius: 5px;
  padding: 12px 20px;

  text-decoration: none;
  display: block;
  min-width: 200px;
  text-align: center;

  font-family: 'Ubuntu',arial;
 }
`;

export const ButtonLink = ({ id, to, className, children, style }) => {
  return (
    <Wrapper className="button-link">
      <Link {...{id, to, style, className}}>{children}</Link>
    </Wrapper>
  );
};

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/components/Form/ButtonLink.js